<template>
  <transition :name="isLocking ? 'fade-in' : 'slide-up'">
    <div
      v-if="showBanner && gtagId"
      class="block-overlay-cookie"
      :class="{ 'is-locking': isLocking }"
    >
      <div class="block-overlay-cookie__inner">
        <div class="block-overlay-cookie__texts">
          <div v-if="title" class="block-overlay-cookie__title">
            <AtomTextHeading html-tag="div" font-size="h2" :text="title" />
          </div>

          <AtomTextRichtext :html="text" />

          <div class="block-overlay-cookie__links">
            <UtilRouteLink
              v-for="(link, index) in links"
              :key="`cookie-banner-link-${index}`"
              :text="link.text"
              :link="link.href"
            />
          </div>
        </div>

        <div class="block-overlay-cookie__buttons">
          <AtomButton
            v-for="(button, index) in buttons"
            :key="`cookie-banner-button-${index}`"
            type="button"
            :text="button.text"
            :background-color="index === 0 ? 'var(--c-primary)' : 'var(--c-primary-200)'"
            :border-color="index === 0 ? 'var(--c-primary)' : 'var(--c-primary-200)'"
            :text-color="index === 0 ? 'var(--c-white)' : 'var(--c-primary)'"
            @click="setUsersChoice(button.action)"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },

    isLocking: {
        type: Boolean,
        default: false,
    },

    title: {
        type: String,
        default: 'Cookie Consent',
    },

    text: {
        type: String,
        default: 'This website uses cookies to ensure you get the best experience on our website.',
    },

    links: {
        type: Array,
        default: () => [],
    },

    buttons: {
        type: Array,
        default: () => [],
    },

    gtagId: {
        type: String,
        default: '',
    },
});

/*
  Check for existing cookies and
  start tracking or show banner
*/
const showBanner = ref(props.isOpen);
const acceptedAll = useCookie('cookies-accepted-all');
const acceptedRequired = useCookie('cookies-accepted-required');

onMounted(() => {
    if (!acceptedAll.value && !acceptedRequired.value) {
        showBanner.value = true;
    }

    // Always initialize GTM

    initGtm();
    // if (acceptedAll.value) {
    // }
});
/*
  set cookies and hide banner and start tracking (if allowed)
*/
const setUsersChoice = (action) => {
    showBanner.value = false;

    switch (action) {
    case 'accept-all':
        acceptedAll.value = true;
        acceptedRequired.value = true;
        return;
        case 'accept-essential':
          acceptedRequired.value = true;
          break;
          default:
            break;
          }

};

</script>

<style lang="scss">
.block-overlay-cookie {
    @include z-index('cookie');
    position: fixed;
    right: var(--page-padding);
    bottom: var(--page-padding);
    display: flex;
    width: calc(100vw - (var(--page-padding) * 2));
    max-width: 480px;
    padding: 45px;
    border-radius: var(--b-radius-700);
    background-color: var(--c-card--bg);
    box-shadow: var(--box-shadow--cookie);
    font-family: var(--f-family--primary);

    &.is-locking{
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        max-width: unset;
        height: 100dvh;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(5px);
        background: rgba(255, 255, 255, 0.75);
    }
}

.block-overlay-cookie__links {
    display: flex;
    flex-wrap: wrap;
    color: var(--c-primary);
    gap: 10px;
    text-decoration: underline;
    text-underline-offset: 4px;
}

.block-overlay-cookie__inner {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 20px;
}

.block-overlay-cookie__texts {
    display: flex;
    width: 100%;
    flex-direction: column;
    row-gap: 20px;
}

.block-overlay-cookie__buttons {
    display: flex;
    flex-wrap: wrap;
    margin-top: 15px;
    column-gap: 10px;
}

.block-overlay-cookie__button {
    @include fluid-simple('height', 50px, 60px);

    display: flex;
    width: 50%;
    align-items: center;
    justify-content: center;
    color: var(--c-primary);
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;

    &:last-child {
        background: var(--c-primary);
        color: var(--c-white);

    }
}
</style>
